import { render, staticRenderFns } from "./DeleteTicket.vue?vue&type=template&id=3c0ca2e1&scoped=true&"
import script from "./DeleteTicket.vue?vue&type=script&lang=js&"
export * from "./DeleteTicket.vue?vue&type=script&lang=js&"
import style0 from "./DeleteTicket.vue?vue&type=style&index=0&id=3c0ca2e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0ca2e1",
  null
  
)

component.options.__file = "DeleteTicket.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
})
